<h5 [ngClass]="{'black-text': isTextBlack}">{{text}}</h5>